import * as tslib_1 from "tslib";
import { MatDialogRef } from '@angular/material';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { sentry } from 'sentry';
import { environment } from '../../../../environments/environment';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { ExportDialogService } from './services/export-dialog.service';
var ExportDialogComponent = /** @class */ (function () {
    function ExportDialogComponent(data, matDialogRef, authenticationService, customMessageService, exportDialogService, fuseProgressBarService, fuseTranslationLoaderService) {
        this.data = data;
        this.matDialogRef = matDialogRef;
        this.authenticationService = authenticationService;
        this.customMessageService = customMessageService;
        this.exportDialogService = exportDialogService;
        this.fuseProgressBarService = fuseProgressBarService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.isExporting = false;
        this.exceedLimitCount = this.data.limit;
        this.email = this.authenticationService.user && this.authenticationService.user.email;
        this.hasExceededLimit = this.data.limit && this.data.total && this.data.total > this.data.limit;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    ExportDialogComponent.prototype.export = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var optionsFormValue_1, input, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.isExporting = true;
                        this.fuseProgressBarService.show();
                        optionsFormValue_1 = (this.data.optionsForm && this.data.optionsForm.value) || {};
                        input = this.exportDialogService.toCreateExportParams({
                            type: this.data.type,
                            where: this.data.where,
                            include: Object.keys(optionsFormValue_1).filter(function (key) { return Boolean(optionsFormValue_1[key]); })
                        });
                        return [4 /*yield*/, this.exportDialogService.createExport(input)];
                    case 1:
                        _a.sent();
                        this.customMessageService.success('EXPORT_DIALOG.MESSAGES.EXPORT_SUCCESS', {}, {
                            text: 'Ver exportações',
                            callback: function () {
                                location.href = environment.MOUNTDOOM_2_URL + '/#/exportacoes';
                            }
                        });
                        return [3 /*break*/, 4];
                    case 2:
                        err_1 = _a.sent();
                        sentry.captureException(err_1, {
                            extra: {
                                dialogData: this.data
                            }
                        });
                        this.customMessageService.error('EXPORT_DIALOG.MESSAGES.EXPORT_ERROR');
                        return [3 /*break*/, 4];
                    case 3:
                        this.isExporting = false;
                        this.matDialogRef.close();
                        this.fuseProgressBarService.hide();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return ExportDialogComponent;
}());
export { ExportDialogComponent };
